import { Link } from "react-router-dom";

const SRC = "/gtforce-logo.jpg";

export default function Logo({ dark = false, size = "md", to = "/" }) {
  const h = size === "lg" ? "h-14" : size === "sm" ? "h-9" : "h-12";
  return (
    <Link to={to} className="flex items-center group" data-testid="gtforce-logo">
      <span className={`inline-flex items-center ${dark ? "bg-white rounded-lg px-2 py-1 shadow-sm" : ""}`}>
        <img src={SRC} alt="GTForce — Global Task Force" className={`${h} w-auto object-contain group-hover:scale-[1.02] transition-transform`} />
      </span>
    </Link>
  );
}
